import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DateFormat, Language } from '@nimbus-library/features/localization/models/enums/language.enum';
import { ILocalizationService } from '@nimbus-library/features/localization/services/i-localization.service';

@Injectable({ providedIn: 'root' })
export class WallboardLocalizationService extends ILocalizationService {
  public loadUserLanguage(): Observable<Language | null> {
    return of(null);
  }

  public saveUserLanguage(): Observable<void> {
    return of(undefined);
  }

  public loadUserDateFormat(): Observable<DateFormat | null> {
    return of(null);
  }

  public saveUserDateFormat(): Observable<void> {
    return of(undefined);
  }
}
